import React, { useEffect } from 'react'
import Head from 'next/head'
import isMobile from 'ismobilejs'
import { WebsiteLayout } from '@website/components/layout/WebsiteLayout'
import { HeroDownload } from '@ui/hero'
import { Meta } from '@website/components/Meta'
import { AntMoney } from '@ui/components/Svg'
import { APP_STORE_LINK, GOOGLE_PLAY_LINK } from '@ui/constants'

const title = 'Download ATM.com App'
const canonical = 'https://www.atm.com/download'
const description = ''

export function Index() {
  useEffect(() => {
    const userAgent = navigator.userAgent
    const mobileInfo = isMobile(userAgent)
    const redirectLink = mobileInfo.android.phone
      ? GOOGLE_PLAY_LINK
      : mobileInfo.apple.phone
        ? APP_STORE_LINK
        : null

    if (redirectLink) {
      window.location.href = redirectLink
    }
  }, [])

  return (
    <>
      <Head>
        <title>{title}</title>
        <Meta title={title} description={description} canonical={canonical} />
      </Head>
      <WebsiteLayout headerClassName="bg-off-white">
        <HeroDownload className="bg-off-white flex min-h-[calc(100vh-112px)] flex-col items-center justify-center pb-14">
          <AntMoney className="xs:max-h-[150px] flex h-full max-h-[200px] w-full items-center justify-center md:max-h-[300px] lg:max-h-none" />
        </HeroDownload>
      </WebsiteLayout>
    </>
  )
}

export default Index
